__turbopack_context__.v({
  "base": "animated-background-module-scss-module__AvY5cG__base",
  "bgOrbFadeIn": "animated-background-module-scss-module__AvY5cG__bgOrbFadeIn",
  "bgOrbFloat": "animated-background-module-scss-module__AvY5cG__bgOrbFloat",
  "bgScanlinesFadeIn": "animated-background-module-scss-module__AvY5cG__bgScanlinesFadeIn",
  "bgScanlinesPulse": "animated-background-module-scss-module__AvY5cG__bgScanlinesPulse",
  "bgShapeFadeIn": "animated-background-module-scss-module__AvY5cG__bgShapeFadeIn",
  "bgShapeFloat": "animated-background-module-scss-module__AvY5cG__bgShapeFloat",
  "grid": "animated-background-module-scss-module__AvY5cG__grid",
  "mouseLight": "animated-background-module-scss-module__AvY5cG__mouseLight",
  "noise": "animated-background-module-scss-module__AvY5cG__noise",
  "orb": "animated-background-module-scss-module__AvY5cG__orb",
  "particle": "animated-background-module-scss-module__AvY5cG__particle",
  "radialOverlay": "animated-background-module-scss-module__AvY5cG__radialOverlay",
  "root": "animated-background-module-scss-module__AvY5cG__root",
  "scanlines": "animated-background-module-scss-module__AvY5cG__scanlines",
  "shape": "animated-background-module-scss-module__AvY5cG__shape",
  "shapeCircle": "animated-background-module-scss-module__AvY5cG__shapeCircle",
  "shapeHexagon": "animated-background-module-scss-module__AvY5cG__shapeHexagon",
  "shapeSquare": "animated-background-module-scss-module__AvY5cG__shapeSquare",
  "shapeTriangle": "animated-background-module-scss-module__AvY5cG__shapeTriangle",
  "vignette": "animated-background-module-scss-module__AvY5cG__vignette",
});
